<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder mb-0">{{ $t('association.Address') }}</h5>
    <p class="mb-0 text-sm">{{ $t('association.Mandatory_informations') }} *</p>
    <div class="multisteps-form__content">
      <div class="row mt-4">
        <div class="col-8">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('association.Address') }} *</label>
            <input v-model="localFormData.address" type="text" class="form-control form-control-default" :placeholder="$t('association.Address')">
            <span v-if="v$.address.$error" class="text-sm text-danger">
              {{ v$.address.$errors[0].$message }}
            </span>
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('association.House_number') }} *</label>
            <input v-model="localFormData.houseNumber" type="text" class="form-control form-control-default" :placeholder="$t('association.House_number')">
            <span v-if="v$.houseNumber.$error" class="text-sm text-danger">
              {{ v$.houseNumber.$errors[0].$message }}
            </span>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('association.City') }} *</label>
            <input v-model="localFormData.city" type="text" class="form-control form-control-default" :placeholder="$t('association.City')">
            <span v-if="v$.city.$error" class="text-sm text-danger">
              {{ v$.city.$errors[0].$message }}
            </span>
          </div>
        </div>      
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('association.Zipcode') }} *</label>
            <input v-model="localFormData.zipcode" type="text" class="form-control form-control-default" :placeholder="$t('association.Zipcode')">
            <span v-if="v$.zipcode.$error" class="text-sm text-danger">
              {{ v$.zipcode.$errors[0].$message }}
            </span>
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="">{{ $t('association.Country') }} *</label>
            <input v-model="localFormData.country" type="text" class="form-control form-control-default" :placeholder="$t('association.Country')">
            <span v-if="v$.country.$error" class="text-sm text-danger">
              {{ v$.country.$errors[0].$message }}
            </span>
          </div>
        </div>
      </div>
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm null null js-btn-prev" type="button" @click="this.$parent.prevStep">Prev</button>
        <button class="btn mb-0 btn-sm bg-gradient-success null null ms-auto js-btn-next" type="button" @click="validateAndNextStep">Next</button>        
      </div>
    </div>
  </div>
</template>

<script>
  import useVuelidate from '@vuelidate/core'
  import { required, helpers } from '@vuelidate/validators'
  import { computed, reactive, watch } from 'vue'
  import { useI18n } from 'vue-i18n'

export default {
  name: "AddressSection",
  props: {
    formData: Object,
    nextStep: Function
  },
  setup(props, { emit }) {
    const { t } = useI18n()

    const localFormData = reactive({ ...props.formData })

    const rules = computed(() => ({
      houseNumber: { required: helpers.withMessage(t('common.Required'), required) },
      address: { required: helpers.withMessage(t('common.Required'), required) },
      city: { required: helpers.withMessage(t('common.Required'), required) },
      zipcode: { required: helpers.withMessage(t('common.Required'), required) },
      country: { required: helpers.withMessage(t('common.Required'), required) },
    }))
    
    const v$ = useVuelidate(rules, localFormData)

    watch(localFormData, () => {
      emit('update:formData', localFormData)
    }, { deep: true })

    const validateAndNextStep = async () => {
      v$.value.$touch() // Mark all fields as touched
      console.log(v$.value.$pending);
      if (v$.value.$pending) {
        await v$.value.$validate() // Ensure validation completes
      }
      if (!v$.value.$invalid) {
        props.nextStep()
      }
    }

    return {
      localFormData,
      v$,
      validateAndNextStep
    }
  }
};
</script>